import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateTokensState from './tokens';

export default (state = initialState, action) => chooseReducer(state, action, updateTokensState);
